module.exports = __webpack_public_path__ + "static/b2-26710692f8a360d05e67fe2377a6aaa2.jpg";